import { action } from 'satcheljs';

const selectAction = action(
    'selectSuggestedRepliesOptionAction',
    function selectSuggestedRepliesOptionAction(isEnabled: boolean) {
        return {
            isEnabled: isEnabled,
        };
    }
);

const discardAction = action('discardSuggestedRepliesOptionAction');

const saveAction = action('saveSuggestedRepliesOptionAction');

const updateAction = action('updateSuggestedRepliesOptionAction');

export { selectAction, discardAction, saveAction, updateAction };
